import { connect, MapStateToProps } from 'react-redux';
import { Props } from './GroupsList';
import { getGroupsStream } from '../../redux/selectors';
import { AddToGroupsPanelStoreSlice } from '../../redux/types';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';

type StateProps = Pick<
  Props,
  'streamId' | 'groups' | 'isFetching' | 'isRecommendedGroupsEnabled'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AddToGroupsPanelStoreSlice
> = state => ({
  ...getGroupsStream(state),
  isRecommendedGroupsEnabled: flagEnabled(state, 'recommended_groups'),
});

export default connect(mapStateToProps);
